import { Field, ErrorMessage } from 'formik';

// Only allow US and Canada
const ALLOWED_COUNTRIES = [
  { value: 'US', label: 'United States' },
  { value: 'CA', label: 'Canada' },
];

const Country = ({ loading }) => {

  return (
    <div>
      <label htmlFor='country'>Country</label>

      <Field
        id='country'
        as='select'
        aria-label='country'
        name='country'
        disabled={loading}>

        <option key='' value=''></option>

        {
          ALLOWED_COUNTRIES.map(item => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))
        }

      </Field>

      <ErrorMessage
        name='country'
        component='div'
      />
    </div>
  );
};

export default Country;